import { Component, OnInit, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { LoaderService } from './Common/loader.service';
import { VersionCheckService } from './Services/version-check.service';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {TranslateService as langService} from './i18n/translate.service';
import {Router, NavigationEnd} from '@angular/router';
declare var config;
declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewChecked {
  // language = "en";
  title = 'CellDe-Online';
  ApiURL = config.APIURL;
  public showLoader;


  constructor(private _loaderService: LoaderService, private cdRef: ChangeDetectorRef, private versionCheckService: VersionCheckService,
    private translate: TranslateService, private _translatelang :langService, public router: Router ) {
    this.translate.use(config.ML_Language);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', config.GooleAnalysticMeasurementID, 
        {
          'page_path': config.HistoryEventName + event.urlAfterRedirects
        }
       );
      }
    });
  }
  ngOnInit() {

    if (environment.production) {
      this.versionCheckService.initVersionCheck(environment.versionCheckURL);
    }
    this._loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }


  onLanguageChange(lang : any)
  {
    this._translatelang.use(lang);
  }

  ngAfterViewChecked() {

    this.cdRef.detectChanges();
  }
}
